class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.replaceCartVariantIds();

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  replaceCartVariantIds() {
    const variantIdReplacements = {
      '45010192269600': '55604590936447',
      '55082710172031': '55604590969215', // ISO WHEY Neutral 2300g Dose → 19%-MwSt-Kopie
      '57707291836799': '57707679252863', // ISO WHEY Neutral 900g Beutel → 19%-MwSt-Kopie
      // weitere Paare ...
    };

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const updates = [];

        cart.items.forEach((item, index) => {
          console.log(`🛒 Prüfe Variante ${item.variant_id} im Warenkorb...`);
          const originalId = item.variant_id.toString();
          const replacementId = variantIdReplacements[originalId];

          if (replacementId && replacementId !== originalId) {
            console.log(`🛒 Ersetze Variante ${originalId} mit ${replacementId} im Warenkorb.`);

            // Erst alte Variante entfernen
            updates.push(
              fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
                },
                body: JSON.stringify({
                  line: index + 1,
                  quantity: 0
                })
              })
              .then(() => {
                // Dann neue Variante hinzufügen
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: parseInt(replacementId),
                    quantity: item.quantity
                  })
                });
              })
              .then(res => res.json())
              .then(response => {
                if (response.status || response.message || response.description) {
                  console.error(`❌ Ersetzung fehlgeschlagen für ${originalId} → ${replacementId}:`, response);
                } else {
                  console.log(`✅ Ersetzung erfolgreich für ${originalId} → ${replacementId}.`);
                }
              })
              .catch(err => {
                console.error(`❌ Fehler bei Ersetzung ${originalId} → ${replacementId}:`, err);
              })
            );
          }

        });

        return Promise.all(updates);
      })
      .then(() => {
        console.log('🛒 Varianten wurden im Warenkorb ersetzt.');
        // Optional: Drawer-Abschnitte neu rendern
        if (this.dataset?.url) {
          fetch(this.dataset.url)
            .then(res => res.text())
            .then(html => {
              document.getElementById('mini-cart').innerHTML =
                this.getSectionInnerHTML(html, '.shopify-section');
            });
        }
      })
      .catch(console.error);
  }

}

customElements.define('mini-cart', MiniCart);
